import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ca3bccc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "worth" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box_list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 桌面级生成式AI应用平台 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_paragraph, null, {
        default: _withCtx(() => [
          _createTextVNode(" 提供丰富的热门AI应用和适配国内主流AI大模型，实现即插即用的便捷体验 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.list, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            ref_for: true,
            ref: "item",
            class: _normalizeClass(["item", [`i_${index+1}`,index+1===$data.expand.active?'active':'']])
          }, [
            _createVNode(_component_a_typography_title, { level: 5 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */),
            _createVNode(_component_a_typography_paragraph, null, {
              default: _withCtx(() => [
                _createCommentVNode("<p v-for=\"v in item.text\">"),
                _createCommentVNode("  {{ v }}"),
                _createCommentVNode("</p>"),
                _createTextVNode(" " + _toDisplayString(item.text), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */)
          ], 2 /* CLASS */))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _createVNode(_component_a_space, {
        size: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'large':'small'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.clickToWhiteBook()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 免费部署 ")
            ]),
            _: 1 /* STABLE */
          }),
          _createCommentVNode("<a-button type=\"link\" class=\"button_n_3\""),
          _createCommentVNode("          @click=\"$Store.Page().openModal('modalFormCollection', 'demo')\">"),
          _createCommentVNode("  预约咨询"),
          _createCommentVNode("</a-button>")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["size"])
    ])
  ]))
}